import { NgModule, Injectable } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    OverlayModule as CkdOverlayModule,
    OverlayContainer,
    OVERLAY_DEFAULT_CONFIG,
    CDK_CONNECTED_OVERLAY_DEFAULT_CONFIG,
    CdkConnectedOverlayConfig
} from '@angular/cdk/overlay';
import { A11yModule } from '@angular/cdk/a11y';
import { OverlayTriggerDirective } from './directives/overlay-trigger.directive';
import { OverlayTargetDirective } from './directives/overlay-target.directive';
import { OverlayComponent } from './components/overlay.component';

@Injectable()
export class CustomOverlayContainer extends OverlayContainer {
    protected _createContainer(): void {
        const container = document.createElement('div');
        container.classList.add(OverlayComponent.CDK_OVERLAY_CONTAINER_CLASS);
        container.classList.add('agpr-clickOutsideExcluded');
        document.body.appendChild(container);
        this._containerElement = container;
    }
}

export const commonOverlayImports = [
    CommonModule,
    CkdOverlayModule,
    A11yModule
];


export const commonOverlayDeclarations = [
    OverlayComponent,
    OverlayTriggerDirective,
    OverlayTargetDirective
];

export const commonImports = [];

@NgModule({
    imports: commonOverlayImports,
    declarations: commonOverlayDeclarations,
    exports: commonOverlayDeclarations,
    providers: [
        { provide: OverlayContainer, useClass: CustomOverlayContainer },
        // CDK defaults overlays to the native Popover API (top layer), which always paints above
        // regular z-indexed content and breaks our $overlay-zIndex stacking (e.g. dropdowns nested
        // inside a popover). Opt back into the classic overlay-container-based stacking model.
        { provide: OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } },
        { provide: CDK_CONNECTED_OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } as unknown as CdkConnectedOverlayConfig }
    ]
})
export class OverlayModule { }
